import {
    AUTH_JWT_TOKEN
} from "@compass/core";
import * as signalR from "@microsoft/signalr";
import {
    HubName
} from "generated/openApi";
import { useEffect, useState } from "react";

export const useTextingConversationsHubConnection = () => {
  const jwtToken = localStorage.getItem(AUTH_JWT_TOKEN);
  const [connectionStatus, setConnectionStatus] = useState<signalR.HubConnectionState>(
    signalR.HubConnectionState.Connecting
  );

  const [textingConversationsHubConnection] = useState<signalR.HubConnection>(
    new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_TEXTING_API_ENDPOINT}/${HubName[HubName.TextingConversationsHub]}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => jwtToken!,
      })
      .withAutomaticReconnect()
      .build()
  );

  // register connection
  useEffect(() => {
    textingConversationsHubConnection
      .start()
      .then(() => {
        console.log("Connection established! Current state:", textingConversationsHubConnection.state);
        setConnectionStatus(textingConversationsHubConnection.state);
      })
      .catch((err) => {
        console.error("Connection failed:", err);
        setConnectionStatus(signalR.HubConnectionState.Disconnected);
      });

    // Set up event handlers for connection state changes
    textingConversationsHubConnection.onclose(() => {
      setConnectionStatus(signalR.HubConnectionState.Disconnected);
    });

    textingConversationsHubConnection.onreconnecting(() => {
      console.log("onreconnecting");
      setConnectionStatus(signalR.HubConnectionState.Reconnecting);
    });

    textingConversationsHubConnection.onreconnected(() => {
      console.log("onreconnected");
      setConnectionStatus(signalR.HubConnectionState.Connected);
    });

    // this is for both inbound messages, and outbound messages that are sent by other users
    // textingConversationsHubConnection.on(
    //   TextingConversationsHubAction[TextingConversationsHubAction.NewMessage],
    //    // handleIncomingMessage
    // );

    return () => {
      textingConversationsHubConnection.stop();
    };
  }, []);

  return { textingConversationsHubConnection, connectionStatus };
};
